import { render, staticRenderFns } from "./AccordeonPrice.vue?vue&type=template&id=70c4b971&scoped=true&"
import script from "./AccordeonPrice.vue?vue&type=script&lang=js&"
export * from "./AccordeonPrice.vue?vue&type=script&lang=js&"
import style0 from "./AccordeonPrice.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AccordeonPrice.vue?vue&type=style&index=1&id=70c4b971&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c4b971",
  null
  
)

export default component.exports